export default __webpack_public_path__ + "static/media/googlepay.c9806c18.svg";